import { Component, OnInit, inject } from '@angular/core';
import { LiveClass } from '../../shared/core/state/live-class/models/live-class';
import { Store } from '@ngrx/store';
import { State } from '../../shared/core/state';

import * as LiveClassActions from '../../shared/core/state/live-class/live-class.action';
import { Router } from '@angular/router';
import { FormatterService } from '../../shared/util/formatter.service';
import { toLiveClassCardViewModel } from '../../shared/util/ui-card.mapper';
import { UiCardViewModel } from '@black/ui';

@Component({
  selector: 'black-my-live-classes',
  templateUrl: './my-live-classes.component.html',
  styleUrl: './my-live-classes.component.css',
  standalone: false,
})
export class MyLiveClassesComponent implements OnInit {
  private store = inject<Store<State>>(Store);
  private router = inject(Router);
  private formatter = inject(FormatterService);

  myClasses: LiveClass[] = [];
  myClassCards: UiCardViewModel[] = [];
  isMyClassesLoading = true;

  ngOnInit(): void {
    this.store.dispatch(LiveClassActions.fetchSubscribedLiveClasses());
    this.store
      .select((state) => state.liveClass.subscribedLiveClasses)
      .subscribe((subscribedClasses) => {
        this.myClasses = subscribedClasses;
        this.myClassCards = subscribedClasses.map((item) =>
          toLiveClassCardViewModel(item, this.formatter, {
            isEnrolled: true,
          })
        );
        this.isMyClassesLoading = false;
      });
  }

  onClickDetails(id: string) {
    this.router.navigate(['live-classes', id]);
  }

  onClickContinue(id: string) {
    this.router.navigate(['meetings']);
  }

  onClickJoinMeetings(id: string) {
    this.router.navigate(['meetings']);
  }

  onClickAccessResources(id: string) {
    this.router.navigate(['my-learnings', 'live-class', id]);
  }

  onViewDetails(id: string): void {
    // TODO: Implement view details functionality
    console.log('View details for class:', id);
  }

  onStartClass(id: string): void {
    // TODO: Implement start class functionality
    console.log('Start class:', id);
  }
}
